import loadable from '@loadable/component';

export { STATE_NAME } from './constants';

export const LoadableAlertbar = loadable(() =>
  import(/* webpackChunkName: "Alertbar" */ './containers/Alertbar'),
);

export { alertsReducer } from './reducer';
